export class RoutesPath {
  public static readonly HOME = '';
  public static readonly ABOUT = 'a-propos';
  public static readonly EXPERTISE = 'expertise';
  public static readonly PROJECTS = 'realisations';
  public static readonly ARTICLES = 'articles';
  public static readonly STORES = 'boutiques';
  public static readonly CONTACT_STORE = 'boutique-contact';
  public static readonly CONTACT_B2B = 'b2b-contact';
  public static readonly CONTACT = 'contact';
  public static readonly MIDDLE_OFFICE = 'middle';
  public static readonly PARTNERS = 'partenaires';
  public static readonly B2B = 'b2b';
  public static readonly AUTH_CALLBACK = 'auth/callback';
}
